@if (filteredLinks?.length > 0) {
  <nav class="navbar navbar-expand-xxl navbar-light navigation navigation--main">
    <button class="navbar-toggler navigation__toggler mt-3" type="button" data-bs-toggle="collapse" data-bs-target="#WebAboNav"
            aria-controls="WebAboNav" aria-expanded="false" aria-label="Toggle navigation"
            (click)="isCollapsed = !isCollapsed">
      <span class="navbar-toggler-icon navigation__toggler-icon"></span>
    </button>
    <div style="position:relative; width:100%;">
      <div id="WebAboNav" class="collapse navbar-collapse navigation__collapse" [ngbCollapse]="isCollapsed">
        <ul [className]="'navbar-nav navigation__list' + ( horizontalNavigation && isCollapsed
                ? 'flex-row navigation__list--horizontal'
                : 'flex-column navigation__list--vertical' )">
          @for (link of filteredLinks; track link) {
            @if (link.showInNavigation) {
              <li class="nav-item navigation__item" (click)="isCollapsed = !isCollapsed">
                @if (link.link !== 'login') {
                    @if (link.isExtern) {
                      <a class="nav-link navigation__link navigation__link--extern"
                         (click)="navigateToExternRoute(link)">{{ link.description }}</a>
                    } @else {
                      <a class="nav-link navigation__link" [routerLink]="link.link" routerLinkActive="active"
                         data-cy="navLink">{{ link.description }}</a>
                    }
                } @else {
                    <a class="nav-link navigation__link navigation__link--login" tabindex="0"
                       (keydown.space)="onClickEvent()" (keydown.enter)="onClickEvent()" (click)="onClickEvent()">
                      <app-login #login></app-login>
                    </a>
                }
              </li>
            }
          }
        </ul>
      </div>
    </div>
  </nav>
}
